import React from 'react';

// ============================================================================
// Real Web3 SVG Icons Library
// ============================================================================

export interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  strokeWidth?: number | string;
  [key: string]: any;
}

export interface TokenLogoProps {
  token?: any;
  symbol?: string;
  coinId?: any;
  size?: number;
  className?: string;
}

// Social Icons
export const TwitterIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className} aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

export const DiscordIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className} aria-hidden="true">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994.021-.041.001-.09-.041-.106a13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.929 1.793 8.18 1.793 12.061 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.894.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.028zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

export const TelegramIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className} aria-hidden="true">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 0 0-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
  </svg>
);

export const GithubIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className} aria-hidden="true">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.53 1.032 1.53 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0 0 22 12.017C22 6.484 17.522 2 12 2z"/>
  </svg>
);

// Blockchain & Network Icons
export const BnbIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="BNB">
    <circle cx="16" cy="16" r="16" fill="#F3BA2F"/>
    <path d="M12.116 14.404L16 10.52l3.886 3.886 2.26-2.26L16 6 9.856 12.144l2.26 2.26zm-6.116 1.6l2.26-2.26L10.52 16l-2.26 2.26L6 16.004zm6.116 1.6l-2.26 2.26L16 26l6.144-6.144-2.26-2.26L16 21.48l-3.884-3.876zm9.768-1.6l2.26-2.26L26 16l-2.26 2.26-1.968-1.956zm-2.26 0L16 12.496l-3.504 3.508 3.504 3.504 3.504-3.504z" fill="#FFFFFF"/>
  </svg>
);

export const EthereumIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Ethereum">
    <circle cx="16" cy="16" r="16" fill="#627EEA"/>
    <g fill="#FFFFFF" fillRule="nonzero">
      <path d="M16.498 4v8.87l7.497 3.35z" fillOpacity=".6"/>
      <path d="M16.498 4L9 16.22l7.498-3.35z"/>
      <path d="M16.498 21.968v6.027L24 17.616z" fillOpacity=".6"/>
      <path d="M16.498 27.995v-6.027L9 17.616z"/>
      <path d="M16.498 20.573l7.497-4.353-7.497-3.348z" fillOpacity=".2"/>
      <path d="M9 16.22l7.498 4.353v-7.701z" fillOpacity=".6"/>
    </g>
  </svg>
);

export const PolygonIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Polygon">
    <circle cx="16" cy="16" r="16" fill="#8247E5"/>
    <path d="M21.13 13.067c-.456-.264-1.026-.264-1.482 0l-2.736 1.58-1.824 1.053-2.736 1.58c-.456.264-.741.76-.741 1.288v3.16l-2.029-1.171c-.456-.264-.741-.76-.741-1.288V13.89c0-.528.285-1.024.741-1.288l4.472-2.583c.456-.264 1.026-.264 1.482 0l4.472 2.583c.456.264.741.76.741 1.288v1.654l-1.839 1.062v-2.539zm-3.322 8.353c.456.264 1.026.264 1.482 0l2.736-1.58 1.824-1.053 2.736-1.58c.456-.264.741-.76.741-1.288v-3.16l2.029 1.171c.456.264.741.76.741 1.288v5.381c0 .528-.285 1.024-.741 1.288l-4.472 2.583c-.456.264-1.026.264-1.482 0l-4.472-2.583c-.456-.264-.741-.76-.741-1.288v-1.654l1.839-1.062v2.537z" fill="#FFFFFF"/>
  </svg>
);

export const AvalancheIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Avalanche">
    <circle cx="16" cy="16" r="16" fill="#E84142"/>
    <path d="M19.167 19.333H23.5L16 6.333 13.5 10.667l3.667 6.333h-4.334L11 13.833 7.5 20h11.667l-2.167 3.667L19.167 19.333z" fill="#FFFFFF"/>
    <path d="M21.5 23.667h-4l2-3.5 2 3.5z" fill="#FFFFFF"/>
  </svg>
);

export const ArbitrumIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Arbitrum">
    <circle cx="16" cy="16" r="16" fill="#28A0F0"/>
    <path d="M16 6l8 13.856-4 2.308-4-6.928-4 6.928-4-2.308L16 6z" fill="#FFFFFF"/>
    <path d="M16 17.536l2.5 4.33H13.5l2.5-4.33z" fill="#28A0F0"/>
  </svg>
);

export const OptimismIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Optimism">
    <circle cx="16" cy="16" r="16" fill="#FF0420"/>
    <path d="M11.5 10.5C9.015 10.5 7 12.515 7 15s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5zm0 6.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm9-6.5h-3.5v9h3.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zm0 6.5h-1v-4h1a2 2 0 0 1 0 4z" fill="#FFFFFF"/>
  </svg>
);

export const BaseIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Base">
    <circle cx="16" cy="16" r="16" fill="#0052FF"/>
    <path d="M16 8a8 8 0 1 0 8 8h-4a4 4 0 1 1-4-4v-4z" fill="#FFFFFF"/>
  </svg>
);

export const OpBnbIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="opBNB">
    <circle cx="16" cy="16" r="16" fill="#F3BA2F"/>
    <path d="M17 7l-7 11h6l-2 7 8-11h-6l1-7z" fill="#181A1F"/>
  </svg>
);

export const HucIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="HuanChain">
    <defs>
      <linearGradient id="hucGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0152ea" />
        <stop offset="50%" stopColor="#ec4899" />
        <stop offset="100%" stopColor="#06b6d4" />
      </linearGradient>
    </defs>
    <rect width="32" height="32" rx="8" fill="url(#hucGradient)"/>
    <path d="M10 8v16h3.5v-6h5v6H22V8h-3.5v6.5h-5V8H10z" fill="#FFFFFF"/>
  </svg>
);

export const TestnetFlaskIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Testnet">
    <circle cx="16" cy="16" r="16" fill="#0ea5e9"/>
    <path d="M19 8h-6v2h1v4.25L9.67 21.05A2 2 0 0 0 11.37 24h9.26a2 2 0 0 0 1.7-2.95L18 14.25V10h1V8zm-1.5 6.75l3.25 5.25H11.25l3.25-5.25V10h3v4.75z" fill="#FFFFFF"/>
  </svg>
);

// Protocol Icons (Bridge)
export const LayerZeroIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="LayerZero">
    <circle cx="16" cy="16" r="16" fill="#1e1e1e"/>
    <path d="M10 10h12v3H13.5l8.5 7.5V22H10v-3h8.5L10 11.5V10z" fill="#FFFFFF"/>
  </svg>
);

export const WormholeIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Wormhole">
    <circle cx="16" cy="16" r="16" fill="#1B1339"/>
    <circle cx="16" cy="16" r="10" stroke="#00FFA3" strokeWidth="2.5" fill="none"/>
    <circle cx="16" cy="16" r="5" stroke="#FFFFFF" strokeWidth="2" fill="none"/>
  </svg>
);

export const StargateIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Stargate">
    <circle cx="16" cy="16" r="16" fill="#000000"/>
    <path d="M16 6l3 7 7 3-7 3-3 7-3-7-7-3 7-3 3-7z" fill="#00E5FF"/>
  </svg>
);

export const MultichainIcon = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="Multichain">
    <circle cx="16" cy="16" r="16" fill="#294CB8"/>
    <path d="M11 13a3 3 0 0 1 3-3h2v2h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2v2h-2a3 3 0 0 1-3-3v-6zm10 6a3 3 0 0 1-3 3h-2v-2h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-2v-2h2a3 3 0 0 1 3 3v6zm-7-2h4v-2h-4v2z" fill="#FFFFFF"/>
  </svg>
);

// UI Utility Icons
export const WalletIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
    <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
    <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
  </svg>
);

export const CopyIcon = ({ size = 16, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
);

export const CheckIcon = ({ size = 16, color = '#10b981', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

export const LockIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </svg>
);

export const ExternalLinkIcon = ({ size = 16, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
    <polyline points="15 3 21 3 21 9"></polyline>
    <line x1="10" y1="14" x2="21" y2="3"></line>
  </svg>
);

export const WarningIcon = ({ size = 18, color = '#f59e0b', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
    <line x1="12" y1="9" x2="12" y2="13"></line>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
);

// Navigation Action Icons
export const NavOverviewIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor', className = '', ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...rest}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
  </svg>
);

export const NavSwapIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor', className = '', ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...rest}>
    <path d="M16 3l4 4-4 4" />
    <path d="M20 7H4" />
    <path d="M8 21l-4-4 4-4" />
    <path d="M4 17h16" />
  </svg>
);

export const NavLiquidityIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor', className = '', ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...rest}>
    <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
  </svg>
);

export const NavBridgeIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor', className = '', ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...rest}>
    <path d="M4 18h16" />
    <path d="M4 18V9a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9" />
    <path d="M9 18V12a3 3 0 0 1 6 0v6" />
    <path d="M2 18h20" />
  </svg>
);

export const NavFaucetIcon: React.FC<IconProps> = ({ size = 18, color = 'currentColor', className = '', ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} {...rest}>
    <path d="M2 12h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2" />
    <path d="M6 16h4" />
    <path d="M10 8V6a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v2" />
    <path d="M8 8h8" />
    <path d="M10 8v8h4V8" />
    <circle cx="12" cy="20" r="1" fill={color} />
  </svg>
);

export const BusdIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="BUSD">
    <circle cx="16" cy="16" r="16" fill="#F0B90B"/>
    <path d="M9 10h6a4 4 0 0 1 2.5 7.1A4.5 4.5 0 0 1 20 21.5a4.5 4.5 0 0 1-4.5 4.5H9V10zm3.5 3v3.5h2.5a1.75 1.75 0 1 0 0-3.5h-2.5zm0 6.5V23H15a1.75 1.75 0 1 0 0-3.5h-2.5z" fill="#FFFFFF"/>
  </svg>
);

export const UsdtIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="USDT">
    <circle cx="16" cy="16" r="16" fill="#26A17B"/>
    <path d="M17.922 17.383c-.09.006-.315.02-.63.02-.855 0-1.74-.06-1.74-.06v-2.07h4.868v-2.613H11.58v2.613h2.12v2.07s-.885.06-1.74.06c-.315 0-.54-.014-.63-.02C8.61 17.15 6.5 15.82 6.5 14.22c0-1.78 2.62-3.23 6.06-3.41v2.34c-.21.01-.42.03-.64.05-2.06.18-3.42.84-3.42 1.62 0 .78 1.36 1.44 3.42 1.62.22.02.43.04.64.05v4.29c.5.03 1.03.05 1.58.05.54 0 1.06-.02 1.56-.05v-4.29c.21-.01.42-.03.64-.05 2.06-.18 3.42-.84 3.42-1.62 0-.78-1.36-1.44-3.42-1.62-.22-.02-.43-.04-.64-.05v-2.34c3.44.18 6.06 1.63 6.06 3.41 0 1.6-2.11 2.93-4.828 3.163z" fill="#FFFFFF"/>
  </svg>
);

export const UsdcIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="USDC">
    <circle cx="16" cy="16" r="16" fill="#2775CA"/>
    <path d="M16 6.5C10.753 6.5 6.5 10.753 6.5 16s4.253 9.5 9.5 9.5 9.5-4.253 9.5-9.5-4.253-9.5-9.5-9.5zm.9 14.5v1.5h-1.8v-1.5c-1.8-.3-3.1-1.4-3.1-3h1.8c.2.8.9 1.4 2.2 1.4 1.3 0 2-.6 2-1.4 0-.8-.7-1.2-1.9-1.5l-1.1-.3c-1.8-.4-2.8-1.4-2.8-2.8 0-1.5 1.2-2.6 2.9-2.9v-1.5h1.8v1.5c1.5.3 2.7 1.3 2.8 2.7h-1.8c-.2-.7-.8-1.2-1.9-1.2-1.1 0-1.8.6-1.8 1.3 0 .7.6 1.1 1.8 1.4l1.1.3c2 .5 3 1.4 3 2.9 0 1.7-1.3 2.7-3.1 3z" fill="#FFFFFF"/>
  </svg>
);

export const DaiIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="DAI">
    <circle cx="16" cy="16" r="16" fill="#F5AC37"/>
    <path d="M11 9h5.5C19.5 9 22 11.5 22 14.5c0 1.5-.7 2.8-1.7 3.7.8.8 1.4 1.9 1.4 3.1 0 2.9-2.4 5.2-5.4 5.2H11V9zm2.4 2.2v13.1h2.9c1.7 0 3-1.3 3-3s-1.3-3-3-3h-1.5v-1.8h1.5c1.4 0 2.5-1.1 2.5-2.6 0-1.4-1.1-2.6-2.5-2.6h-2.9z" fill="#FFFFFF"/>
  </svg>
);

export const UniIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="UNI">
    <circle cx="16" cy="16" r="16" fill="#FF007A"/>
    <path d="M12.5 9C12.5 9 14 12 17 12s4-2 4-2 1.5 4-1 6-4 1-5 3-1 4-1 4-1-3 0-5 2-3 2-4-2-2-3.5-5z" fill="#FFFFFF"/>
  </svg>
);

export const LinkIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="LINK">
    <circle cx="16" cy="16" r="16" fill="#375BD2"/>
    <path d="M16 8l7 4v8l-7 4-7-4v-8l7-4zm0 2.5l-4.8 2.8v5.4l4.8 2.8 4.8-2.8v-5.4L16 10.5z" fill="#FFFFFF"/>
  </svg>
);

export const CakeIcon = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-label="CAKE">
    <circle cx="16" cy="16" r="16" fill="#D1884F"/>
    <path d="M16 8c-3 0-5 2-5 5v1h10v-1c0-3-2-5-5-5zm-7 8v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6H9z" fill="#FFFFFF"/>
    <circle cx="16" cy="6.5" r="1.5" fill="#FFEBAA"/>
  </svg>
);

// High-fidelity UI Feature Icons
export const ZapIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
  </svg>
);

export const RocketIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
    <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
    <path d="M9 12H4s.55-3.03 2-4.5c1.62-1.63 5-2.5 5-2.5"/>
    <path d="M15 12v5s3.03-.55 4.5-2c1.63-1.62 2.5-5 2.5-5"/>
  </svg>
);

export const DropsIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
  </svg>
);

export const ChartBarIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <line x1="12" y1="20" x2="12" y2="10"></line>
    <line x1="18" y1="20" x2="18" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="16"></line>
  </svg>
);

export const UsersIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

export const ShieldLockIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <rect x="9" y="11" width="6" height="5" rx="1"></rect>
    <path d="M10 11V9a2 2 0 1 1 4 0v2"></path>
  </svg>
);

export const TrendingUpIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);

export const CoinsIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="8" cy="8" r="6"></circle>
    <path d="M18.09 10.37A6 6 0 1 1 10.34 18"></path>
    <path d="M7 6h2v4H7z"></path>
  </svg>
);

export const BankIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M3 21h18M3 10h18M5 10v11M9 10v11M15 10v11M19 10v11M12 3l9 7H3l9-7z"></path>
  </svg>
);

export const ClipboardIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
  </svg>
);

export const GlobeIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

export const ErrorIcon = ({ size = 16, color = '#ef4444', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  </svg>
);

export const InfoIcon = ({ size = 16, color = '#3b82f6', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

export const PendingIcon = ({ size = 16, color = '#f59e0b', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

export const ChevronDownIcon = ({ size = 14, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

export const SwitchVerticalIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M7 16V4m0 0L3 8m4-4l4 4"></path>
    <path d="M17 8v12m0 0l4-4m-4 4l-4-4"></path>
  </svg>
);

export const CloseIcon = ({ size = 16, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

export const SearchIcon = ({ size = 16, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

export const PlusIcon = ({ size = 16, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

export const ArrowRightIcon = ({ size = 18, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);


// Map network key to React icon component
export const getNetworkIcon = (networkKey, size = 20) => {
  switch (networkKey) {
    case 'bsc_mainnet':
    case 'mainnet':
      return <BnbIcon size={size} />;
    case 'bsc_testnet':
      return <TestnetFlaskIcon size={size} />;
    case 'ethereum':
    case 'ethereum_mainnet':
      return <EthereumIcon size={size} />;
    case 'ethereum_testnet':
      return <EthereumIcon size={size} />;
    case 'polygon':
      return <PolygonIcon size={size} />;
    case 'avalanche':
      return <AvalancheIcon size={size} />;
    case 'arbitrum':
      return <ArbitrumIcon size={size} />;
    case 'optimism':
      return <OptimismIcon size={size} />;
    case 'opbnb':
      return <OpBnbIcon size={size} />;
    case 'base':
      return <BaseIcon size={size} />;
    case 'huc':
      return <HucIcon size={size} />;
    default:
      return <BnbIcon size={size} />;
  }
};

// Unified Token Logo Component (Real icons instead of emojis)
export const TokenLogo: React.FC<TokenLogoProps> = ({ token, symbol: propSymbol, coinId: propCoinId, size = 24, className = '' }) => {
  const symbol = (token?.symbol || propSymbol || '').toUpperCase();
  const coinId = token?.coinId || propCoinId;

  if (coinId) {
    return (
      <img 
        src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coinId}.png`} 
        alt={symbol} 
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'contain' }}
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
    );
  }

  switch (symbol) {
    case 'BNB':
    case 'WBNB':
      return <BnbIcon size={size} className={className} />;
    case 'ETH':
    case 'WETH':
    case 'GOERLIETH':
      return <EthereumIcon size={size} className={className} />;
    case 'USDT':
      return <UsdtIcon size={size} className={className} />;
    case 'USDC':
      return <UsdcIcon size={size} className={className} />;
    case 'BUSD':
      return <BusdIcon size={size} className={className} />;
    case 'CAKE':
      return <CakeIcon size={size} className={className} />;
    case 'DAI':
      return <DaiIcon size={size} className={className} />;
    case 'UNI':
      return <UniIcon size={size} className={className} />;
    case 'LINK':
      return <LinkIcon size={size} className={className} />;
    case 'MATIC':
      return <PolygonIcon size={size} className={className} />;
    case 'AVAX':
      return <AvalancheIcon size={size} className={className} />;
    case 'HUC':
    default:
      return <HucIcon size={size} className={className} />;
  }
};

